const secToMin = (seconds: number) => {
  const asMinutes = Math.floor(seconds / 60);
  return asMinutes;
};

const secToMinDec = (seconds: number) => {
  const asMinutes = (seconds / 60).toFixed(2);
  return asMinutes;
};

const secToMinHr = (seconds: number) => {
  const asMinutes = seconds / 60;

  const hours = Math.floor(asMinutes / 60);
  const mins = Math.floor(asMinutes % 60);

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (mins > 0) parts.push(`${mins}m`);

  return {
    hours: hours,
    mins: mins,
    text: parts.length > 0 ? parts.join(' ') : '0m',
  };
};

const secToMinHrSec = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds - hours * 3600) / 60);
  const secs = Math.floor(seconds - hours * 3600 - mins * 60);

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (mins > 0) parts.push(`${mins}m`);
  if (secs > 0) parts.push(`${secs}s`);

  return {
    hours: hours,
    mins: mins,
    secs: secs,
    text: parts.length > 0 ? parts.join(' ') : '0s',
  };
};

const secToDaysHrMinSec = (seconds: number) => {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds - days * 86400) / 3600);
  const mins = Math.floor((seconds - days * 86400 - hours * 3600) / 60);
  const secs = Math.floor(seconds - days * 86400 - hours * 3600 - mins * 60);

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (mins > 0) parts.push(`${mins}m`);
  if (secs > 0) parts.push(`${secs}s`);

  return {
    days: days,
    hours: hours,
    mins: mins,
    secs: secs,
    text: parts.length > 0 ? parts.join(' ') : '0s',
  };
};

const secToDaysHrMin = (seconds: number) => {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds - days * 86400) / 3600);
  const mins = Math.floor((seconds - days * 86400 - hours * 3600) / 60);
  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (mins > 0) parts.push(`${mins}m`);
  return parts.length > 0 ? parts.join(' ') : '0h';
};

export { secToMin, secToMinDec, secToMinHr, secToMinHrSec, secToDaysHrMinSec, secToDaysHrMin };
